import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(tools)/image-tools/super-resolution/ToolClientWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientToolShell"] */ "/vercel/path0/components/ui/ClientToolShell.tsx");
